import React, { useContext } from 'react';
import { useLocalStorage } from 'utils/useLocalStorage';

import FleetFiltersContext from 'modules/fleet/filters/context';

const GatekeepingFiltersContext = React.createContext();

const gatekeepingDefaultFilters = {};

function GatekeepingFiltersContextProvider({
  defaultFilters = gatekeepingDefaultFilters,
  children,
}) {
  const { filters: fleetFilters } = useContext(FleetFiltersContext);
  const [filters, setFilters] = useLocalStorage('gatekeeping/filters', defaultFilters);

  const composedFilters = { ...fleetFilters, ...filters };

  const value = {
    filters: composedFilters,
    setFilters,
  };

  return (
    <GatekeepingFiltersContext.Provider value={value}>
      {children(value)}
    </GatekeepingFiltersContext.Provider>
  );
}

export default GatekeepingFiltersContext;
export { gatekeepingDefaultFilters, GatekeepingFiltersContextProvider };
